export default __webpack_public_path__ + "static/media/dessert-background.4bab1d78.jpg";